<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Obra</span>
        <h3 class="page-title">Adicionar</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <project-page v-if="!isCustomer"/>
        <d-list-group flush v-else>
            <d-list-group-item class="p-3">
              <d-row>
                <d-col>
                  <h4>Oops! Você não tem permissão para estar aqui. <i class="far fa-smile text-warning"></i></h4>
                </d-col>
              </d-row>
            </d-list-group-item>
          </d-list-group>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import ProjectPage from '_modules/project/components/ProjectPage.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/ProjectModel';

export default {
  name: 'project-create',
  components: {
    ProjectPage,
  },
  computed: {
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
  },
  created() {
    Events.$emit(_LOAD_MODEL_, MODEL);
    Events.$emit('sidebarVisible', false);
  },
};
</script>

